// src/lib/opportunity/oppTodoItemTypes.ts

export type OppTodoItem = {
  id: string;
  organization_id: string;
  opportunity_id: string;
  template_step_id: string | null;
  label: string;
  sort_order: number;
  due_date: string | null;
  completed_at: string | null;
  completed_by_user_id: string | null;
  created_by_user_id: string | null;
  created_at: string;
  updated_at: string;
};

/** Statuses where reps can add, edit, reorder, or delete todo rows. */
export const OPP_TODO_EDITABLE_STATUSES = ["ordered", "in_process"] as const;

export function isOpportunityTodosEditable(status: string): boolean {
  return (OPP_TODO_EDITABLE_STATUSES as readonly string[]).includes(status);
}

export function isOppTodoItemOpen(item: Pick<OppTodoItem, "completed_at">): boolean {
  return item.completed_at == null;
}
